<template>
	<v-container fluid>
		<v-row class="mb-3 d-flex justify-space-between">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="mr-2" size="x-large" style="color: #ff7e87">mdi-text-box-outline</v-icon>
					<p class="text-lg-h5 font-weight-600">{{ $t('demand') }}</p>
				</div>
			</v-col>

			<v-col cols="5" md="5" class="d-flex align-center justify-end">
				<v-text-field variant="plain" density="compact" hide-details class="box-shadow isRounded pb-1 pl-1"
					:placeholder="$t('search')" style="
						border: 1px solid rgba(181, 183, 192, 1);
						background-color: rgba(255, 255, 255, 1);
						border-radius: 16px;
						padding: 8px, 16px, 8px, 16px;
					">
					<template v-slot:prepend>
						<div>
							<v-icon style="color: rgba(0, 0, 0, 1); font-size: 30px" class="ml-2"
								@click="searchAgent">mdi-magnify</v-icon>
						</div>
					</template>
				</v-text-field>
			</v-col>
		</v-row>
		<v-card v-if="isFetchingIncidents" height="400px" class="d-flex" align="center">
			<v-card-text class="text-center my-auto">
				<v-progress-circular color="grey" :size="80" indeterminate class="mb-4 mx-auto" />
				<div>Generating Report...</div>
			</v-card-text>
		</v-card>

		<v-card v-show="isFetchingDemands === false">
			<v-card-text>
				<div class="dashboard">
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						@totalRowsPerPage="filterRowsPerPage" @pageNumber="changePage" @delete="deleteDemand"
						@delete-without-confirm="deleteDemandWithoutConfirm" />
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="isDeletePopupOpen" width="500px">
			<v-card>
				<v-card-title class="font-weight-bold mx-3 mt-2">
					{{ $t('delete_demand') }} ?</v-card-title>
				<v-card-text>
					<div>
						{{ $t('would_like_delete_demand') }} ?
						<span style="color: rgba(255, 126, 135, 1)">
							{{ $t('permanent_delete_demenad') }}</span>
					</div>
				</v-card-text>
				<v-card-footer>
					<div class="d-flex flex-row-reverse ma-3">
						<div>
							<v-btn rounded="xl" style="background-color: rgba(255, 194, 198, 1)"
								@click="demandDelete">{{
									$t('confirm') }}</v-btn>
						</div>
						<div>
							<v-btn variant="text" @click="isDeletePopupOpen = false">{{ $t('cancel') }}</v-btn>
						</div>
					</div>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbarMove" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">
					Incident has been moved to incident list as draft.
				</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbarMove = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
		<v-snackbar v-model="snackbarDelete" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Demand has been deleted .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbarDelete = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import DemandDataTable from '@/components/DemandDataTable.vue'
import customerInfo from '@/services/API/customerInfo.js'
import settings from '@/services/API/settings'
export default {
	components: {
		'data-table': DemandDataTable,
	},
	data: () => ({
		demandId: '',
		items: [],
		snackbarMove: false,
		snackbarDelete: false,
		isFetchingDemands: false,
		isDeletePopupOpen: false,
		headers: [
			{
				text: 'Date & Time',
				value: 'updatedAt',
				width: '20%',
				sortable: true,
			},
			{
				text: 'Demand Request',
				value: 'CustomerRequest',
				width: '50%',
			},
			{
				text: 'Pending Day',
				value: 'pendingDay',
				width: '10%',
			},
			{
				text: '',
				value: 'sendToIncident',

				width: '10%',
			},
			{
				text: '',
				value: 'button',
				width: '10%',
			},
		],
	}),
	created() {
		this.getCustomerDemand()
	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Agent name', 'Skills', ''].includes(item.text)
			)
		},
	},
	methods: {
		deleteDemand(data) {
			this.isDeletePopupOpen = true
			this.demandId = data
		},
		deleteDemandWithoutConfirm(id) {
			this.demandId = id
			this.demandDeleteWithoutConfirm()
		},
		async demandDeleteWithoutConfirm() {
			await customerInfo.deleteDemand(this.demandId).then((response) => {
				if (response.status === 200) {
					this.getCustomerDemand()
					this.snackbarMove = true
				}
			})
		},
		async demandDelete() {
			await customerInfo.deleteDemand(this.demandId).then((response) => {
				if (response.status === 200) {
					this.getCustomerDemand()
					this.isDeletePopupOpen = false
					this.snackbarDelete = true
				}
			})
		},
		async changePage(data) {
			this.getCustomerDemand(data)
		},
		async filterRowsPerPage(data) {
			await settings
				.updatePageSettings(localStorage.getItem('userId'), {
					tableRowsPerPage: data,
				})
				.then((response) => {
					this.getCustomerDemand()
				})
				.catch(() => {
					this.isFetchingDemands = true
				})
		},
		async getCustomerDemand(pageNumber) {
			await customerInfo
				.getCustomerDemandList(pageNumber)
				.then((response) => {
					if (response.status == 200) {
						this.items = response.data.data
					}
				})
		},
	},
}
</script>
<style scoped>
.user_container {
	display: flex;
}

.box-shadow {
	box-shadow: 0px 0px 20px 0px rgba(131, 133, 143, 0.2) !important;
}
</style>
